/* @flow */

/**
 * The URL at which Google Chrome is available for download.
 *
 * @type {string}
 */
export const CHROME = 'https://www.google.com/chrome/';

/**
 * The URL at which Chromium is available for download.
 *
 * @type {string}
 */
export const CHROMIUM = 'https://www.chromium.org/';

/**
 * The URL at which Microsoft Edge is available for download.
 *
 * @type {string}
 */
export const EDGE
    = 'https://www.microsoft.com/en-us/windows/microsoft-edge';

/**
 * The URL at which Mozilla Firefox is available for download.
 *
 * @type {string}
 */
export const FIREFOX = 'https://www.getfirefox.com/';

/**
 * The URL at which Safari is available for download.
 *
 * @type {string}
 */
export const SAFARI = 'https://support.apple.com/downloads/safari';
